<template>
  <!-- <page> -->
  <div :load="doInit">
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12 lg12>
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-filter-variant</v-icon> {{label.filters}}
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="ePanelHeaderColor">
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field
                            v-model="form.polNo"
                            :label="label.polNo"
                            :error-messages="errors.collect('polNo')"
                            data-vv-name="polNo"
                            :data-vv-as="label.polNo"
                            append-icon="mdi-magnify"
                            @click:append="showPolicyHelpList = true"
                            v-validate="'required'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field
                            v-model="form.renCnt"
                            :label="label.renCnt"
                            :error-messages="errors.collect('renCnt')"
                            data-vv-name="renCnt"
                            :data-vv-as="label.renCnt"
                            v-validate="'required'"
                            type="number"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>

        <v-flex xs12 sm6 md6 lg6>
          <v-btn class='mr-2' color="primary" type="submit" :loading="loading" @click.prevent="doExport">
            <v-icon left dark>mdi-file-export</v-icon>
            {{ label.export }}
          </v-btn>
          <v-btn-toggle dense mandatory v-model="form.format">
            <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
              <span>{{ format.label }}</span>
              <v-icon :color="format.color">{{ format.icon }}</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-flex>
        </v-layout>
      </v-container>

      <!-- Policy No. HelpList -->
      <v-dialog v-model="showPolicyHelpList" width="1280px">
        <policy-help-list @close="showPolicyHelpList = false" @assign-policy-info="assignPolicy" polHeader="polHeader2"></policy-help-list>
      </v-dialog>
    </div>
  <!-- </page> -->
</template>

<script>
import MessageMixin from '@/mixins/message'
import { reportFormat } from '@/const/report'
import { extractMenu } from '@/utils/extract'
import PolicyHelpList from '@/components/core/common/dialog/PolicyHelpList'

export default {
  data() {
    return {
      label: {
        polNo: 'Policy No.',
        renCnt: 'Renewal Count',
        export: 'Export To',
        filters: 'Filters'
      },
      form: {
        polNo: null,
        renCnt: 0,
        endtCnt: 0,
        format: 'PDF'
      },
      loading: false,
      menu: {},
      supportedFormat: [],
      showPolicyHelpList: false,
      panel1: [0]
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.uwReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map((format) => {
          if (format === 'PDF') {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.uwReports.menu !== 1) {
          await Promise.all([this.$store.dispatch('uwReportsInit')])
        }
        const apiURI = this.rptMenu.initAutoRenCvrLet
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.genRenCvrLet
      if (apiURI) {
        try {
          this.loading = true
          await this.$http.post(apiURI, this.form)
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    assignPolicy(data) {
      this.form.polNo = data.polNo
      this.form.renCnt = data.renCnt
      this.showPolicyHelpList = false
    }
  },
  created() {
    this.doInit()
  },
  mixins: [MessageMixin],
  components: {
    PolicyHelpList
  }
}
</script>

<style>
</style>
